import { defineMessages } from 'react-intl'

export const searchBarMessages = defineMessages({
  all: {
    id: 'components.searchBar.all',
    defaultMessage: 'Search projects, products, news and more'
  },
  articles: {
    id: 'components.searchBar.articles',
    defaultMessage: 'in Articles'
  },
  folders: {
    id: 'components.searchBar.folders',
    defaultMessage: 'in Folders'
  },
  products: {
    id: 'components.searchBar.products',
    defaultMessage: 'in Products'
  },
  projects: {
    id: 'components.searchBar.projects',
    defaultMessage: 'in Projects'
  },
  images: {
    id: 'components.searchBar.medias',
    defaultMessage: 'Image Tags'
  },
  professionals: {
    id: 'components.searchBar.professionals',
    defaultMessage: 'in Professionals'
  },
  'article-archive': {
    id: 'components.searchBar.articleArchive',
    defaultMessage: 'in Archive'
  },
  default: {
    id: 'components.searchBar.default',
    defaultMessage: 'in ArchDaily'
  },
  search: {
    id: 'components.searchBar.search',
    defaultMessage: 'Search'
  },
  noResults: {
    id: 'components.searchBar.no_results',
    defaultMessage: 'No results in {type}. \'<span>Search ArchDaily</span>\''
  }
})
